import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import { notification, Table, Button, Checkbox, Input, Select } from 'antd';

@inject(({ userInfoStore }) => ({
  jobList: userInfoStore.jobList,
  valCondition: userInfoStore.valConditionJob,
  onChangValue: userInfoStore.onChangValueJob,

  disJobList: userInfoStore.disJobList,
  merJobList : userInfoStore.merJobList,
}))
@observer
class JobView extends Component {
  state = {
    jobCd: '',
    jobNm: '',

    saveData: []
  };

  onSearch = () => {
    this.props.disJobList(this.state.jobCd, this.state.jobNm);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.jobList !== this.props.jobList) {
      // this.setState({saveData: nextProps.jobList});
      this.setState({saveData: nextProps.jobList.filter(item => item.jobCd !== '개별사업자')});
    }
  }

  handleReset = () => {
    this.setState({ saveData: this.props.jobList });
  };

  handleChange = (type, name, item, record, index) => {
    const funcChange = (value) => {
      const newData = [...this.state.saveData];
      newData.splice(index, 1, {
        ...record,
        [name]:value,
      });
      this.setState({saveData: newData });
    };

    const chkDisabled = () => {
      let vChk = false;
      this.props.jobList.map((chkItem)=>{return(
        (vChk === false && chkItem.RNUM === record.RNUM) &&
        (vChk = true)
      )});
      return vChk;
    };

    if (type === 'Input') {
      return (
        <Input
          disabled={(this.props.ceType === process.env.REACT_APP_TYPE_YUJIN) 
                    ? ((chkDisabled() === true && name === 'jobCd') ? true : false)
                    : true}
          value={item}
          onChange={(e)=>{
            let str_space = /\s/;               // 공백 체크
            let value = e.target.value;
            if(str_space.exec(value)) {
              value = value.replace(' ',''); // 공백제거
              notification.warning({placement: 'bottomLeft', message: `공백은 사용할 수 없습니다.`, duration: 2});
            }

            funcChange(value);
          }}
          style={{ width: 200 }}
        />
      )
    } else if (type === 'Checkbox') {
      return (
        <Fragment>
          <Checkbox
            disabled={(this.props.ceType === process.env.REACT_APP_TYPE_YUJIN) ? false : true}
            checked={item === 'Y' ? true : false}
            onChange={(e)=>funcChange(e.target.checked ? "Y" : "N")}
          />
          {(chkDisabled() === false && (this.props.ceType === process.env.REACT_APP_TYPE_YUJIN)) &&
          <Fragment>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Button
              onClick={() => this.handleDelete(record.RNUM)}
            >삭제</Button>
          </Fragment>
          }
        </Fragment>
      )
    }
  };

  handleDelete = key => {
    this.setState({ saveData: this.state.saveData.filter(item => item.RNUM !== key) });
  };

  handleAdd = () => {
    let newData = {
      RNUM: Date.now(),
      jobCd: "",
      jobNm: "",
      jobUseYn: "Y",
    };
    this.setState({
      saveData: [
        newData,
        ...this.state.saveData
      ]
    });
  };

  handleSave = () => {
    const { saveData } = this.state;
    // 빈값 체크 Start
    let emptyChk = false;
    let emptyChkIdx = 0;
    saveData.map((item, idx)=>{ return (
      ((item.jobCd === "" ||  item.jobNm === "") && emptyChk === false) &&
        (emptyChk = true, emptyChkIdx = idx + 1)
    )});

    if (emptyChk === true) {
      notification.warning({placement: 'bottomLeft', message: `${emptyChkIdx}번째 값을 입력하세요.`, duration: 2});
      return false;
    }
    // 빈값 체크 End
    
    // 중복체크 Start
    let boolChk = false;
    let ChkIdx1 = 0;
    let ChkIdx2 = 0;
    saveData.map((item, idx)=>{ return (
      saveData.map((chkItem, chkIdx)=>{ return (
        (item.jobCd === chkItem.jobCd && boolChk === false && idx !== chkIdx) && 
        (boolChk = true,
          ChkIdx1 = idx + 1,
          ChkIdx2 = chkIdx + 1)
      )})
    )});

    if (boolChk === true) {
      notification.warning({placement: 'bottomLeft', message: `${ChkIdx1}번째,${ChkIdx2}번째의 직무코드가 중복됩니다.`, duration: 2});
      return false;
    }
    // 중복체크 End

    this.props.merJobList(saveData);
  };

  render() {
    const { jobCd, jobNm, saveData } = this.state;
    const { ceType, valCondition, onChangValue } = this.props;
    const columns = [
      { title: '직무코드', dataIndex: 'jobCd', key: 'jobCd', width: '40%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('Input', 'jobCd', item, record, index)
        )}
      },
      { title: '직무명', dataIndex: 'jobNm', key: 'jobNm', width: '40%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('Input', 'jobNm', item, record, index)
        )}
      },
      { title: '사용유무', dataIndex: 'jobUseYn', key: 'jobUseYn', width: '20%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('Checkbox', 'jobUseYn', item, record, index)
        )}
      }
    ];

    return (
      <Fragment>
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">직무코드</span>
              <Input 
                placeholder="직무코드를 입력하세요"
                value={jobCd}
                onChange={(e)=>this.setState({jobCd: e.target.value})}
                onPressEnter={this.onPressEnter}
                style={{ width: 200 }}
              />
            </span>
            <span className="mo_srch">
              <span className="labal2">직무명</span>
              <Input 
                placeholder="직무명을 입력하세요"
                value={jobNm}
                onChange={(e)=>this.setState({jobNm: e.target.value})}
                onPressEnter={this.onPressEnter}
                style={{ width: 200 }}
              />
            </span>
            <span className="mo_srch">
              <span className="labal2">사용여부</span> 
              <Select
                style={{ width: 150, marginRight: '20px' }}
                value={valCondition.jobUseYn}
                onChange={(value)=>{
                  onChangValue('jobUseYn', value);
                  this.onSearch();
                }}
              >
                <Select.Option key={''}>전체</Select.Option>
                <Select.Option key={'Y'}>사용</Select.Option>
                <Select.Option key={'N'}>미사용</Select.Option>
              </Select>
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>
        <div className="button-group">
          <div style={{ color: 'red' }}>{process.env.REACT_APP_WARNING}</div>
          {(ceType === process.env.REACT_APP_TYPE_YUJIN) &&
            <div className="button-right">
              <ul>
                <li><Button onClick={this.handleAdd}>직무추가</Button></li>
                <li><Button onClick={this.handleReset}>초기화</Button></li>
                <li><Button type="primary" onClick={this.handleSave}>저장</Button></li>
              </ul>
            </div>
          }
        </div>

        <Table
          rowClassName={() => 'editable-row'}
          bordered
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={saveData}
          pagination={false}
          scroll={{ y: 700 }}
        />
        <br />
      </Fragment>
    );
  }

}

export default withRouter(JobView);
